
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/expert/[slug]",
      function () {
        return require("private-next-pages/blog/expert/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/expert/[slug]"])
      });
    }
  